export default __webpack_public_path__ + "static/soehne-web-fett-58ba8a0e8fbaba2668c17a49f2374aea.woff";